"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContentstackURL = void 0;
// Contentstack docs: https://www.contentstack.com/docs/developers/apis/content-delivery-api

var getContentstackURL = exports.getContentstackURL = function getContentstackURL(_ref) {
  var contentType = _ref.contentType,
    entryId = _ref.entryId,
    env = _ref.env,
    _ref$include = _ref.include,
    include = _ref$include === void 0 ? [] : _ref$include,
    _ref$only = _ref.only,
    only = _ref$only === void 0 ? [] : _ref$only,
    query = _ref.query;
  var url = new URL("https://cdn.contentstack.io/v3/content_types/".concat(contentType, "/entries").concat(entryId ? "/".concat(entryId) : ''));
  url.searchParams.set('environment', env);
  if (query) {
    url.searchParams.set('query', JSON.stringify(query));
  }
  if (include.length > 0) {
    include.forEach(function (inc) {
      return url.searchParams.append('include[]', inc);
    });
  }
  if (only.length > 0) {
    only.forEach(function (_ref2) {
      var field = _ref2.field,
        refUid = _ref2.refUid;
      url.searchParams.append("only[".concat(refUid, "][]"), field);
    });
  }
  return url.toString();
};